// extracted by mini-css-extract-plugin
export default {"products":"Lx-z","card":"Mx-z","oosMessaging":"Nx-z"};